import {
  IoTrashOutline,
  IoAddCircle,
  IoCalendarClearOutline,
  IoPaperPlaneOutline,
  IoMapOutline,
  IoSettingsOutline,
  IoThermometerOutline,
  IoBusinessOutline,
  IoPersonCircleOutline,
  IoAirplaneOutline,
  IoAnalyticsOutline,
  IoKeyOutline,
  IoCloseCircleOutline,
  IoWarningOutline,
  IoCloseSharp,
  IoCashOutline,
} from 'react-icons/io5';
import {
  BiCurrentLocation,
  BiCheck,
  BiChevronRight,
  BiChevronLeft,
  BiChevronDown,
  BiChevronUp,
  BiSearch,
  BiReset,
  BiDislike,
  BiLike,
  BiLogInCircle,
  BiZoomIn,
} from 'react-icons/bi';
import { FiEdit, FiShare2, FiLogOut } from 'react-icons/fi';
import { GiSaveArrow, GiDeliveryDrone, GiControlTower } from 'react-icons/gi';
import {
  BsPlusCircle,
  BsDashCircle,
  BsArrowsCollapse,
  BsArrowsExpand,
  BsCheck,
  BsShieldLock,
  BsUnlock,
  BsDashLg,
} from 'react-icons/bs';
import {
  AiOutlineCloseCircle,
  AiOutlineBars,
  AiOutlineCheck,
  AiOutlinePhone,
  AiFillCloud,
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlineUser,
  AiOutlinePlusCircle,
  AiOutlineMinusCircle,
  AiOutlineClear,
} from 'react-icons/ai';
import {
  RiRoadMapLine,
  RiRulerLine,
  RiWindyLine,
  RiDashboardLine,
  RiMindMap,
} from 'react-icons/ri';
import { TbDatabaseExport } from 'react-icons/tb';
import { FaTemperatureHigh, FaCloudRain } from 'react-icons/fa';
import { TiArrowSortedDown, TiArrowSortedUp } from 'react-icons/ti';
import { CgPlayListCheck } from 'react-icons/cg';
import { WiStrongWind } from 'react-icons/wi';
import { MdOutlineReceipt } from 'react-icons/md';
import ReceiptIcon from '@material-ui/icons/Receipt';
import ClearIcon from '@material-ui/icons/Clear';
import AddIcon from '@material-ui/icons/Add';
import TimelineIcon from '@material-ui/icons/Timeline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import EditIcon from '@material-ui/icons/Edit';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import LocalAirportIcon from '@material-ui/icons/LocalAirport';
import LanguageIcon from '@material-ui/icons/Language';
import Brightness1Icon from '@material-ui/icons/Brightness1';
import ControlCameraIcon from '@material-ui/icons/ControlCamera';
import ScheduleIcon from '@material-ui/icons/Schedule';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import DashboardIcon from '@material-ui/icons/Dashboard';
import CloseIcon from '@material-ui/icons/Close';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
import MapIcon from '@material-ui/icons/Map';
import EditLocationOutlinedIcon from '@material-ui/icons/EditLocationOutlined';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import DoneIcon from '@material-ui/icons/Done';
import HomeWorkOutlinedIcon from '@material-ui/icons/HomeWorkOutlined';
import SettingsIcon from '@material-ui/icons/Settings';
import ContactMailOutlinedIcon from '@material-ui/icons/ContactMailOutlined';
import PermDataSettingOutlinedIcon from '@material-ui/icons/PermDataSettingOutlined';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import FaceOutlinedIcon from '@material-ui/icons/FaceOutlined';
import HistoryIcon from '@material-ui/icons/History';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import EventIcon from '@material-ui/icons/Event';
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import SaveIcon from '@material-ui/icons/Save';

export default {
  Navigation: {
    ArrowLeft: AiOutlineArrowLeft, // ArrowBackIcon // ArrowBackIosIcon
    ArrowRight: AiOutlineArrowRight,
    ArrowLeftIos: ArrowBackIosIcon,
    ArrowRightIos: ArrowForwardIosIcon,
    Left: BiChevronLeft, //  ChevronLeftIcon
    Right: BiChevronRight,
    Up: BiChevronUp, // keyboardarrowdownicon
    Down: BiChevronDown, // ExpandMoreIcon // keyboardarrowupicon
    SortedDown: TiArrowSortedDown,
    SortedUp: TiArrowSortedUp,
    ArrowsExpand: BsArrowsExpand,
    ArrowsCollapse: BsArrowsCollapse,
    LogOut: FiLogOut,
    Settings: IoSettingsOutline,
    ResetWarning: IoWarningOutline,
    BackToLogIn: BiLogInCircle,
    ArrowBack: ArrowBackIcon,
    ArrowDown: ArrowDropDownCircleIcon,
    ArrowChlid: PlayCircleFilledIcon,
  },
  Dashboard: {
    Airplane: IoAirplaneOutline,
    Analytics: IoAnalyticsOutline,
    Key: IoKeyOutline,
    Map: IoMapOutline,
    Dashboard: RiDashboardLine,
    MissionApprovals: ReceiptIcon,
    Settings: SettingsIcon,
  },
  Zoom: {
    PlusCircle: AiOutlinePlusCircle,
    MinusCircle: AiOutlineMinusCircle,
    ZoomIn: BiCurrentLocation,
    ZoomPlus: BsPlusCircle,
    ZoomMinus: BsDashCircle,
    ZoomInOnMap: BiZoomIn,
  },
  Filters: {
    PaperPlane: IoPaperPlaneOutline,
    Map: IoMapOutline,
    MapRoad: RiRoadMapLine,
    Ruler: RiRulerLine,
    ActionSuccess: BsCheck,
    ActionFail: IoCloseSharp,
    NoData: BsDashLg,
    Button: BiCurrentLocation,
    ButtonLike: BiLike,
    ButtonDisLike: BiDislike,
    ButtonPrivate: BsShieldLock,
    ButtonPublic: BsUnlock,
    OpenMission: MdOutlineReceipt,
    Categories: HomeWorkOutlinedIcon,
    Export: TbDatabaseExport,
    ClearCalendar: AiOutlineClear,
  },
  Actions: {
    Accept: BiCheck,
    Add: IoAddCircle,
    Add2: AddIcon,
    Clear: ClearIcon, // X icon
    ControlCamera: ControlCameraIcon, // zoom to the extent
    Edit: FiEdit, // EditIcon
    Edit2: EditIcon,
    Check: AiOutlineCheck, // DoneoutlineIcon
    DoneOutline: DoneOutlineIcon,
    CheckCircle: CheckCircleIcon,
    Close: CloseIcon, // IoCloseCircleOutline // CloseIcon
    CloseCircle: AiOutlineCloseCircle,
    CloseCircle2: IoCloseCircleOutline,
    HighlightOff: HighlightOffIcon, // like x in circle
    RemoveCircle: RemoveCircleIcon,
    Reset: BiReset,
    Save: GiSaveArrow,
    Search: BiSearch,
    SearchFile: OpenInBrowserIcon,
    Preview: VisibilityIcon,
    HidePreview: VisibilityOffIcon,
    SearchEvent: EventIcon,
    Done: DoneIcon,
    Skip: SkipNextIcon,
    Save2: SaveIcon,
  },
  Weather: {
    Cloud: AiFillCloud,
    Temperature: FaTemperatureHigh,
    Thermometer: IoThermometerOutline,
    Rain: FaCloudRain,
    Wind: RiWindyLine,
    WindStrong: WiStrongWind,
  },
  Misc: {
    Dashboard2: DashboardIcon,
    Brightness: Brightness1Icon,
    LocalAirport: LocalAirportIcon,
    Calendar: IoCalendarClearOutline,
    Drone: GiDeliveryDrone,
    Language: LanguageIcon,
    ListCheck: CgPlayListCheck,
    OutlineBars: AiOutlineBars,
    Organization: IoBusinessOutline,
    Phone: AiOutlinePhone,
    RadioUnchecked: RadioButtonUncheckedIcon,
    RadioChecked: RadioButtonCheckedIcon,
    Schedule: ScheduleIcon, // clock
    Share: FiShare2,
    Trash: IoTrashOutline, // DeleteIcon
    Timeline: TimelineIcon,
    User: AiOutlineUser,
    UserPerson: IoPersonCircleOutline,
    SystemSettings: IoSettingsOutline,
    Subscriptions: IoCashOutline,
    Loyalty: CardMembershipIcon,
  },
  DashboardMenu: {
    Public: HomeWorkOutlinedIcon,
    Map: MapIcon,
    Source: RiMindMap,
    Ruler: RiRulerLine,
    EditMap: EditLocationOutlinedIcon,
  },
  USpace: {
    History: HistoryIcon,
  },
  Airspace: {
    AirControl: GiControlTower,
  },
  Settings: {
    Dashboard: PermDataSettingOutlinedIcon,
    User: AssignmentIndOutlinedIcon,
  },
  Profile: {
    ProfileSettings: AccountCircleOutlinedIcon,
    Contact: ContactMailOutlinedIcon,
    LogOut: ExitToAppOutlinedIcon,
    Profile: FaceOutlinedIcon,
  },
};
